export default __webpack_public_path__ + "static/media/VG.c805668f.svg";